import { Facebook, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import React from "react";

const StudentProfile = () => {
  const profile = {
    name: "MUHAMMED S JALLOW",
    title: "Software Engineer",
    photo: "https://i.ibb.co/0DNnYtT/msjallow-profile.png", // Using a placeholder image
    phone: "+91 7842 717444",
    email: "msgambia82@gmail.com",
    address: "123 Visakhapatnam, Andhra Pradesh",
    social: {
      linkedin: "https://linkedin.com/in/msjallow",
      twitter: "https://twitter.com/msjallow",
      facebook: "https://facebook.com/msjallow",
    },
    summary:
      "Experienced Marketing Manager known for driving dynamic and result-oriented marketing strategies. Skilled in crafting influential campaigns to boost brand visibility, connect with target markets, and accomplish tangible business goals. Demonstrates effective leadership, communication abilities, and a sharp insight into market trends. Dedicated to providing creative marketing solutions that foster business expansion.",
    education: [
      {
        degree: "B.Tech Computer Science",
        school: "Andhra University",
        gpa: "3.8 / 4.0",
        year: "2023",
      },
      {
        degree: "Bachelor of Arts in Communication Studies",
        school: "University Name",
        gpa: "3.8 / 4.0",
        year: "2013",
      },
    ],
    skills: [
      "Strategic Planning",
      "Digital Marketing",
      "Data Analysis",
      "Team Leadership",
      "Brand Management",
      "Market Research",
    ],
    languages: ["English", "French", "Fulani"],
    expertise: ["Digital Marketing", "Copywriting", "Branding", "SEO"],
    experience: [
      {
        company: "Borcelle Studio",
        position: "Marketing Manager & Specialist",
        period: "2030 - Present",
        description:
          "Create marketing strategies that match company objectives, guide a top-performing team, and maintain brand consistency across all channels.",
      },
      {
        company: "Fauget Studio",
        position: "Marketing Manager & Specialist",
        period: "2025 - 2029",
        description:
          "Develop and control marketing budgets, supervise market research to identify trends, requirements, and competitor strategies, and maintain brand consistency across all channels.",
      },
      {
        company: "Spotmies Limeted",
        position: "Marketing Manager & Specialist",
        period: "2024 - 2025",
        description:
          "Establish and nurture connections with partners, agencies, and vendors to receive marketing assistance. Maintain brand uniformity across all marketing platforms and materials.",
      },
    ],
  };

  const Section = ({ title, children }) => (
    <div className="mb-6">
      <h3 className="text-xl font-semibold mb-2 text-blue-800 border-b border-blue-200 pb-1">
        {title}
      </h3>
      {children}
    </div>
  );

  return (
    <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden my-8 relative">
      <div className="relative">
        {/* Enlarged Blue Header Card */}
        <div className="bg-blue-600 p-10 text-white rounded-b-lg relative">
          <div className="flex justify-between items-start">
            <div>
              <h1 className="text-5xl font-bold">{profile.name}</h1>
              <h2 className="text-2xl mt-2">{profile.title}</h2>
            </div>
            <div className="absolute top-4 right-4 flex space-x-2">
              <a
                href={profile.social.linkedin}
                className="text-white hover:text-blue-200"
              >
                <Linkedin size={20} />
              </a>
              <a
                href={profile.social.twitter}
                className="text-white hover:text-blue-200"
              >
                <Twitter size={20} />
              </a>
              <a
                href={profile.social.facebook}
                className="text-white hover:text-blue-200"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Contact Information */}
          <div className="mt-4 flex flex-col space-y-2">
            <div className="flex items-center">
              <Phone size={16} className="mr-2" />
              <span>{profile.phone}</span>
            </div>
            <div className="flex items-center">
              <Mail size={16} className="mr-2" />
              <span>{profile.email}</span>
            </div>
            <div className="flex items-center">
              <MapPin size={16} className="mr-2" />
              <span>{profile.address}</span>
            </div>
          </div>

          {/* Profile Image Positioned in the Center */}
          <div className="absolute -bottom-16 left-1/2 transform -translate-x-1/2 w-32 h-32">
            <img
              src={profile.photo}
              alt={profile.name}
              className="w-full h-full rounded-full border-4 border-white object-cover"
            />
          </div>
        </div>
      </div>

      <div className="pt-20 p-6 grid grid-cols-3 gap-6">
        <div className="col-span-1">
          <Section title="Expertise">
            <div className="flex flex-wrap gap-2">
              {profile.expertise.map((exp, index) => (
                <span
                  key={index}
                  className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm"
                >
                  {exp}
                </span>
              ))}
            </div>
          </Section>
          <Section title="Education">
            {profile.education.map((edu, index) => (
              <div key={index} className="mb-2">
                <p className="font-semibold">Graduated {edu.year}</p>
                <p className="text-sm">{edu.degree}</p>
                <p className="text-sm">GPA: {edu.gpa}</p>
              </div>
            ))}
          </Section>
          <Section title="Skills">
            <ul className="list-disc list-inside text-sm">
              {profile.skills.map((skill, index) => (
                <li key={index}>{skill}</li>
              ))}
            </ul>
          </Section>
          <Section title="Language">
            <div className="flex flex-wrap gap-2">
              {profile.languages.map((lang, index) => (
                <span
                  key={index}
                  className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm"
                >
                  {lang}
                </span>
              ))}
            </div>
          </Section>
        </div>

        <div className="col-span-2">
          <Section title="Profile">
            <p className="text-sm">{profile.summary}</p>
          </Section>

          <Section title="Work Experience">
            {profile.experience.map((exp, index) => (
              <div key={index} className="mb-4 bg-blue-50 p-3 rounded">
                <h4 className="font-semibold">{exp.company}</h4>
                <p className="text-sm text-blue-800">{exp.position}</p>
                <p className="text-sm text-gray-600">{exp.period}</p>
                <p className="text-sm mt-1">{exp.description}</p>
              </div>
            ))}
          </Section>
        </div>
      </div>
    </div>
  );
};

export default StudentProfile;



